<template>
  <div id="reportsPage">
    <div class="page-main-bg">
      <v-container class="main-container team-container">
        <!-------------Toolbar----------------------->
        <tool-bar
          v-if="!singleReportView"
          :breadcrumbs="breadcrumbs"
          :length="reports.length"
          :toggle-drawer="toggleDrawer"
          :title="previousReportsView ? 'قائمة التقارير' : 'إنشاء التقارير'"
          class="mb-8"
        />

        <!-- Filter for view category reports -->
        <reportFilter
          class="mt-3"
          v-if="!previousReportsView"
          :filterTypes="preReportsFilterTypes"
          :statusViewCategory="previousReportsView"
          @handleFilterChange="handleFilterCategoryReports"
        />

        <!-------------predefined reports Loader----------------------->
        <loader
          v-if="isPredefinedReprtsLoading && !previousReportsView"
          v-bind="predefinedReportsLoaderProps"
        />

        <!-------------PerReports----------------------->
        <v-row class="mt-1 mb-10" v-else-if="!previousReportsView">
          <template v-for="preReport in preReports">
            <perRportsCard
              :per-reports="preReport"
              :key="preReport._id"
              v-if="isReportAvailable(preReport)"
            />
          </template>
        </v-row>
        <template v-else>
          <template v-if="!singleReportView">
            <!-------------report-Filter------------------>
            <reportFilter
              class="mt-3"
              :filterTypes="filterTypes"
              :statusViewCategory="previousReportsView"
              @handleFilterChange="handleFilterChange"
            >
              <!----MultipleSelectionsForDelete----->
              <MultipleSelectionsForDelete
                v-bind="multipleSelectionsData"
                :showRestoreDeleted="false"
                @changeSelect="selectAllChanged"
                @switched="switched"
              />
            </reportFilter>

            <v-row>
              <v-col class="property-col" cols="12">
                <!--Loader-->
                <loader v-if="isPageLoading" v-bind="loaderProps" />

                <!--no reports-->
                <no-data v-else-if="!reports.length" v-bind="noDataProps" />

                <div v-else>
                  <!------ data-table-report ---->
                  <data-table-reports
                    v-bind="dataTableBondProps"
                    @del-report="delReport"
                    @changeVisibility="toggleReportVisibility"
                    @setReportId="setClickedReportData"
                  />
                </div>
              </v-col>
            </v-row>
            <!--Pagination-->
            <div
              class="text-center mt-6 mb-5"
              v-if="pagination.pagesCount > 1 && previousReportsView"
            >
              <Pagination :pagination="pagination" @onChange="getReports()" />
            </div>
          </template>
          <template v-else>
            <singleReport
              @backToReports="setSingleReportView(false)"
              :clickedReport="clickedReport"
            />
          </template>
        </template>

        <!------ add-report-modal ---->
        <add-reports-modal
          v-bind="addReportModelProps"
          @changeDialogState="changeDialogState($event)"
          @refresh-reports="getReports"
          @togglepreviousReportsView="togglepreviousReportsView"
        />

        <div
          v-if="!singleReportView && !isCustomer"
          class="d-flex align-center justify-end ml-md-8 fast-actions"
        >
          <v-btn
            @click="togglepreviousReportsView"
            class="font-weight-bold fast-actions-btn pa-5 font-12"
            color="primary"
            large
          >
            <img
              class="mx-2 icon-invert"
              :src="addingIcon"
              loading="lazy icon-invert"
            />
            {{ addShowReportBtn }}
          </v-btn>

          <!-------Fast actions---------->
          <fastActions />
        </div>
        <v-card-actions
          class="d-flex align-center justify-end ml-md-8 ml-5 fast-actions rounded-15"
          style="left: 25px; bottom: 25px"
          v-if="isCustomer"
        >
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            class="ma-0 rounded-15 my-1 d-flex px-3 ml-5 fast-actions-btn pa-5 px-5"
            @click="makeRouterRequest('report')"
          >
            <img
              :width="18"
              :height="18"
              class="ml-2 icon-invert"
              src="@/assets/Icons_Legacy/reports.svg"
            />
            <span class="mb-1 mobile__mb__0 ml-1 font-weight-bold mt-1 font-12">
              طلب تقرير
            </span>
          </v-btn>
        </v-card-actions>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import { reportService } from '@/services/report.service.js'
import { MultipleDeletion, requestsService } from '@/services/'
import multipleSelections from '@/mixins/multipleSelections'
import DataTableReports from '@/components/reports/data-table-reports'
import ToolBar from '@/components/listing/ToolBar'
import PerRportsCard from '@/components/reports/PerRportsCard'
import Pagination from '@/components/helper/pagination.vue'
import reportFilter from '@/components/reports/reportFilter.vue'
import MultipleSelectionsForDelete from '@/components/helper/MultipleSelectionsForDelete'
import fastActions from '@/components/helper/fastActions'
import noData from '@/components/helper/noData.vue'
import loader from '@/components/helper/loader.vue'
import singleReport from '@/components/reports/report.vue'
import confirmationMixin from '@/mixins/confirmationMixin.js'

export default {
  name: 'reports',
  mixins: [multipleSelections, confirmationMixin],
  components: {
    AddReportsModal: () => import('@/components/modals/add-reports-modal'),
    Pagination,
    fastActions,
    PerRportsCard,
    DataTableReports,
    ToolBar,
    reportFilter,
    MultipleSelectionsForDelete,
    noData,
    loader,
    singleReport
  },
  data() {
    return {
      isPredefinedReprtsLoading: true,
      addingIcon: require('@/assets/Icons_Legacy/docs.svg'),
      reportsTypes: [],
      previousReportsView: true,
      singleReportView: false,
      clickedReport: {},
      noDataConfig: {
        text: 'لا توجد تقارير مضافة',
        icon: require('@/assets/Icons_Legacy/reports.svg'),
        subTitle: 'يمكن عرض التقارير عند إضافتها من قبل مقدم الخدمة'
      },
      filterTypes: [],
      pagination: {
        pageNumber: 1,
        pagesCount: 0,
        pageSize: 10,
        count: 0
      },
      exceedTitle:
        'لقد  استنفذت العدد المحدد من الإضافات المتاحة في باقتك الحالية وبإمكانك ترقية الباقة لإجراء إضافات جديدة',
      exceedSubTitle:
        'يمكنك ترقية الباقة  الحالية  لباقة أعلى أو التواصل معنا مباشرة في حال كان اشتراكك الحالي في أعلى باقة متاحة',
      isPageLoading: true,
      dialogState: false,
      reports: [],
      reportsCount: 0,
      reportClone: {},
      requestTypes: [],
      breadcrumbs: [{ text: 'التقارير', disabled: true }],
      headers: [
        {
          text: 'عنوان التقرير',
          sortable: false,
          value: 'title'
        },
        { text: 'العقار', align: 'center', value: 'propertyName' },
        { text: 'المالك', align: 'center', value: 'ownerName' },
        { text: 'تاريخ الانشاء', align: 'center', value: 'createdAt' },
        // { text: 'بواسطة', align: 'center', value: 'moderator' },
        {
          text: 'فترة التقرير',
          align: 'center',
          value: 'reportPeriod',
          sortable: false
        },
        {
          text: 'بوابة العملاء',
          align: 'center',
          value: 'accessibleToClient',
          sortable: false
        },
        { text: 'حذف', align: 'center', value: 'actions', sortable: false }
      ],
      reportsType: '',
      sort: '',
      createdAtFilter: '',
      preReportsFilterTypes: [
        {
          _id: '',
          nameAr: 'الكل'
        },
        {
          _id: 'user',
          nameAr: 'تقارير العملاء'
        },
        {
          _id: 'realestate',
          nameAr: 'تقارير العقارات'
        },
        {
          _id: 'financial',
          nameAr: 'تقارير مالية'
        },
        {
          _id: 'accounting',
          nameAr: 'تقارير محاسبية'
        },
        {
          _id: 'collage',
          nameAr: 'تقارير مجمعة'
        }
      ],
      preType: '',
      allPreReports: []
    }
  },
  created() {
    this.$emit('updateInformativeTip', this.$route.meta?.informativeTip)
    if (this.isCustomer) {
      this.previousReportsView = true
    }
    this.getReports()
    this.getRequestTypes()
  },
  watch: {
    previousReportsView(status) {
      if (status) {
        this.reportsType = ''
        this.preType = ''
        this.getReports()
      }
    },
    customerDefaultRole() {
      this.pagination.pageNumber = 1
      this.getReports()
    }
  },
  computed: {
    ...mapState('accountState', [
      'user',
      'currentEnv',
      'configs',
      'subscription',
      'customerDefaultRole'
    ]),
    ...mapGetters('accountState', ['isCustomer']),
    reprtTableHeaders() {
      if (this.$hasPermission('users', 'reports', 'delete')) {
        return this.headers
      }
      const filterdHeaders = this.headers.filter(
        (header) => header.value !== 'checked' && header.value !== 'actions'
      )
      return filterdHeaders
    },

    predefinedReportsLoaderProps() {
      return {
        laoderClasses: 'mx-auto',
        type: 'card',
        numberOfLines: 8
      }
    },
    isBasicBundle() {
      return this.subscription?.bundle?.code === 'basic-bundle'
    },
    addReportModelProps() {
      return {
        report: this.reportClone,
        reportCode: this.reportClone.code,
        reportTypes: this.allPreReports,
        dialogState: this.dialogState
      }
    },
    preReports() {
      return this.allPreReports.filter(({ activePic }) => {
        if (this.preType !== '') {
          return activePic === this.preType
        }
        return activePic
      })
    },
    hasPermission() {
      return this.$hasPermission('users', 'reports', 'add')
    },
    addShowReportBtn() {
      return this.previousReportsView ? 'انشاء تقرير' : 'التقارير السابقه'
    },
    noDataProps() {
      return {
        noDataText: this.noDataConfig.text,
        noDataIcon: this.noDataConfig.icon,
        noDataSubTitle: this.noDataConfig.subTitle
      }
    },
    loaderProps() {
      return {
        numberOfLines: 5,
        laoderClasses: 'my-2 shadow-border-radius pa-0',
        type: 'list-item-avatar-two-line',
        cols: 12
      }
    },
    dataTableBondProps() {
      return {
        headers: this.reprtTableHeaders,
        reports: this.reports,
        reportsTypes: this.reportsTypes,
        isCustomer: this.isCustomer
      }
    },
    /* Multiple selections */
    // ------------------ //
    deleteTitle() {
      return this.showSelectAll ? 'حذف التقارير' : 'حذف التقرير'
    },
    restoreTitle() {
      return this.showSelectAll
        ? 'استرجاع التقارير المحذوفة'
        : 'استرجاع التقرير المحذوف'
    },
    reportsQuery() {
      let query = `${this.currentEnv?._id}?pageNumber=${this.pagination.pageNumber}&pageSize=${this.pagination.pageSize}&type=${this.reportsType}&sort=${this.sort}&createdAt=${this.createdAtFilter}`
      if (this.customerDefaultRole) {
        query += `&userType=${this.customerDefaultRole}`
      }
      if (this.isCustomer) {
        query += `&accessibleToClient=true`
      }
      return query
    }
  },
  methods: {
    ...mapMutations('appState', ['toggleDrawer', 'addNotification']),
    isReportAvailable(report) {
      if (!this.isBasicBundle) {
        return true
      }
      return !!report.isAvailable
    },
    predefinedReports() {
      const data = []
      this.reportsTypes.map((reportT) => {
        const tempObj = { ...reportT }
        tempObj.report = {
          reprtsTypeData: reportT,
          title: reportT.name,
          code: reportT.code,
          sectionFields: [...reportT.sectionFields],
          reportsType: reportT._id,
          moderator: {
            _id: this.user._id,
            name: this.user.name
          },
          environment: this.currentEnv?._id
        }
        data.push(tempObj)
      })
      this.allPreReports = data
    },
    makeRouterRequest(key) {
      // go to request page and opne add request modal and request type will be selected
      this.$router.push({
        name: 'maintenance',
        query: {
          reuquestType: this.requestTypes.find((item) => item.code === key)
        }
      })
    },
    setClickedReportData(item) {
      this.clickedReport = item
      this.setSingleReportView(true)
    },
    togglepreviousReportsView() {
      if (!this.hasPermission) {
        this.addNotification({
          text: 'ليس لديك صلاحية لإضافة تقارير',
          color: 'error'
        })
        return
      }
      this.previousReportsView = !this.previousReportsView
    },
    async getRequestTypes() {
      try {
        const {
          data: { requestTypes }
        } = await requestsService.getRequestsTypes()
        this.requestTypes = requestTypes
      } catch {
        this.addNotification({
          text: 'حدث خطأ ما برجاء إعاده المحاوله',
          color: 'error'
        })
      }
    },
    getReportsType() {
      reportService
        .getReportsTypes()
        .then((res) => {
          res.data.reportType.map((type) => {
            type.mainSection = type.name
            type.icon = `${type.pic}.svg`
            type.activeIcon = `${type.activePic}.svg`
          })
          this.reportsTypes = [...res.data.reportType]
          this.predefinedReports()
        })
        .catch(() => {})
        .finally(() => {
          this.isPredefinedReprtsLoading = false
        })
    },
    changeDialogState(val) {
      this.dialogState = val
      this.reportClone = {}
    },
    reportUserType(report) {
      return report.reportType.options.clients.type === 'owner'
        ? 'المالك'
        : 'المستأجر'
    },
    async toggleReportVisibility(report) {
      this.$root.$confirm
        .open({
          title: report.accessibleToClient
            ? `إزالة التقارير من حساب ${this.reportUserType(report)}`
            : 'إظهار في بوابة العملاء',
          message: report.accessibleToClient
            ? `هل أنت متأكد من إخفاء التقرير من حساب ${this.reportUserType(
                report
              )} فى بوابة العملاء ؟`
            : `هل انت متأكد من إضافة التقرير لقائمة التقارير فى حساب ${this.reportUserType(
                report
              )} فى بوابة العملاء ؟`,
          options: {
            color: 'primary',
            width: 400,
            zIndex: 200
          },
          confirmTxt: 'تأكيد',
          img: {
            path: report.accessibleToClient
              ? require('@/assets/Icons_Legacy/eye-closed.svg')
              : require('@/assets/Icons_Legacy/eye.svg'),
            width: 55,
            height: 55
          }
        })
        .then((confirm) => {
          if (confirm) {
            reportService.changeReportVisibility(report._id, {
              accessibleToClient: !report.accessibleToClient
            })
          }
        })
        .catch(() => {
          this.addNotification({
            text: 'حدث خطاء اثناء تغير حالة التقرير',
            color: 'error'
          })
        })
        .finally(() => {
          this.getReports()
        })
    },
    async getReportFilters() {
      try {
        const res = await reportService.getReportFilters(this.currentEnv?._id)
        this.filterTypes = res.data
        const lastIndex = this.filterTypes.length - 1
        const allObj = {
          nameAr: 'الكل',
          nameEn: 'all',
          _id: ''
        }
        const isTotalElment = this.filterTypes[lastIndex]?.totalCount
        if (isTotalElment) {
          allObj.count = this.filterTypes[lastIndex].totalCount.count
          this.filterTypes.pop()
        } else {
          allObj.count = 0
        }
        this.filterTypes.unshift(allObj)
      } catch {}
    },
    openAddDialog() {
      this.dialogState = true
    },
    getReports() {
      const id = this.isCustomer ? this.user._id : ''
      this.isPageLoading = true
      reportService
        .getReports(this.reportsQuery, id)
        .then((res) => {
          this.pagination.pagesCount = Math.ceil(
            res?.data?.count / this.pagination.pageSize
          )
          this.pagination.count = res?.data?.count ?? 0
          this.isPageLoading = false
          this.reports = res?.data
            ? res.data.reports.map((report) => ({
                ...report,
                checked: false
              }))
            : []
          this.reportsCount = res?.data?.count ?? 0
          if (!this.customerDefaultRole || !this.customerDefaultRole.length) {
            this.getReportFilters()
          }
          this.getReportsType()
        })
        .catch(() => {
          this.isPageLoading = false
        })
    },
    allDeletedReports() {
      // console.log('All delete reports')
    },
    handleFilterChange({ sort, type, createdAt }) {
      this.pagination.pageNumber = 1
      this.reportsType = type
      this.sort = sort.nameEn
      this.createdAtFilter = createdAt
      this.getReports()
    },
    handleFilterCategoryReports({ type }) {
      this.preType = type
    },
    delReport(reportId) {
      this.$root.$confirm
        .open({
          title: 'حذف التقرير',
          message: 'هل أنت متأكد من حذف التقرير، العملية لا يمكن استرجاعها',
          options: {
            color: 'danger',
            width: 400,
            zIndex: 200
          }
        })
        .then((confirm) => {
          if (confirm) {
            reportService
              .delReport(reportId)
              .then(({ data }) => {
                data.needsApproval && this.showConfirmationPopupMixin()
                this.addNotification({
                  text: 'تم حذف  هذا التقرير',
                  color: 'success'
                })
                this.getReports()
              })
              .catch(() => {
                this.addNotification({
                  text: 'حدث خطاء اثناء حذف  هذا التقرير',
                  color: 'error'
                })
              })
          }
        })
    },
    editReport(item) {
      this.reportClone = Object.assign({}, item)
      this.dialogState = true
    },
    /* Multiple selections */
    // ------------------ //
    // Delete reports with multiple selections
    async deleteItems() {
      const message = this.showSelectAll
        ? `هل انت متاكد من حذف التقارير وعددهم ${this.getAllChecked.length}`
        : 'هل انت متاكد من حذف التقرير'
      // 1 - Open popup and confirm delete or not
      const status = await this.$root.$confirm.open({
        title: this.deleteTitle,
        message,
        options: {
          color: 'red'
        }
      })

      // If confirmed
      if (status) {
        try {
          const body = { ids: this.getAllChecked }

          const { data } = await MultipleDeletion.deleteReports(body)
          data.needsApproval && this.showConfirmationPopupMixin()
          this.getReports()
          this.getReportsType()
          this.addNotification({
            text: 'تم الحذف بنجاح',
            color: 'success'
          })
        } catch {
          this.addNotification({
            text: 'حدث خطا يرجى المحاولة مره اخرى',
            color: 'error'
          })
        }
      }
    },
    // Restore reports with multiple selections
    async restoreDelete() {
      const message = this.showSelectAll
        ? `هل انت متاكد من استرجاع التقارير المحذوفة وعددهم ${this.getAllChecked.length}`
        : 'هل انت متاكد من استرجاع التقرير المحذوف'
      //
      const status = await this.$root.$confirm.open({
        title: this.restoreTitle,
        statusRestore: true,
        message,
        options: {
          color: 'red'
        }
      })
    },
    // This will handle all cases switching
    switched(data) {
      const { name, value } = data
      this.statusRestore = value

      if (name === 'deleted') {
        return this.allDeletedReports()
      }
      return this.getReports()
    },
    setSingleReportView(val) {
      this.singleReportView = val
      val
        ? this.$router.replace({
            path: '/dashboard/reports',
            query: { report: this.clickedReport.number }
          })
        : this.$router.replace({ path: '/dashboard/reports' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/material-dashboard/fastactions.scss';
#reportsPage {
  overflow-x: hidden;
}
</style>
